export enum IncidentNature {
  Corrective,
  Positive,
  Neutral
}
